import { takeEvery, takeLatest } from 'redux-saga';
import { put, apply, take, fork } from 'redux-saga/effects';

import history from '../../history';

const sagaUtils = require('redux-saga/lib/internal/utils');
// overide stupid redux-saga error loging
sagaUtils.log = function log(level, message, error) {
  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    if(error && level === 'error'){
      console.error(error && error.stack ? error.stack : error);
    }else{
      console[level](message, error);
    }
  }
};

export default (getState, sagas) => function*() {
  const options = {
    // takeEvery: takeEveryAndWrapError,
    takeEvery: wrap(takeEvery),
    takeLatest: wrap(takeLatest),
    takeFirst: wrap(takeFirst),
    getState
  };
  yield [].concat(sagas).map(saga=> saga(options));
};

function* takeFirst(pattern, saga, ...args) {
  return yield fork(function*() {
    while (true) {
      const action = yield take(pattern);
      yield saga.call({}, ...args.concat(action));
    }
  });
}

function wrap(func) {
  return function (..._args) {
    const args = new Array(_args.length);
    for (let i = 0; i < args.length; ++i) {
      args[i] = i === 1 ? wrapError(_args[i]) : _args[i];
    }
    return func.apply(this, args);
  };
}

function wrapError(method) {
  return function*(...args) {
    try {
      yield method(...args);
    } catch (error) {
      if (console.error) {
        console.error(error.stack);
      }
      // we dispatch an event with the error
      yield put({
        $global: true,
        type: 'ERROR',
        error: true,
        payload: error
      });
      // make sure to redirect if we get an 401 || 403 error
      if (error.name === 'HttpNotAuthorizedError') {
        yield apply(history, history.replace, ['/login']);
      } else if (error.name === 'HttpForbiddenError') {
        yield apply(history, history.replace, ['/login']);
      }
    }
  };
}




// WEBPACK FOOTER //
// ./src/app/state/sagas/index.js